module.exports = __webpack_public_path__ + "img/Menu-03.5200fb3e.png";